import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FormTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import { FolderType } from '../../../../AddToGroupsPanel/redux/types';
const GroupTabs = ({ selectSubmissionType, selectedSubmissionType, className })=>{
    const { t } = useTranslation();
    const tabs = useMemo(()=>[
            {
                index: FolderType.Gallery,
                label: t('addToGroup.folderType.gallery')
            },
            {
                index: FolderType.Collection,
                label: t('addToGroup.folderType.collection')
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ React.createElement(FormTabs, {
        items: tabs,
        activeIndex: selectedSubmissionType,
        onChange: selectSubmissionType,
        className: className
    });
};
GroupTabs.displayName = 'GroupTabs';
export default GroupTabs;
